import {AfterViewInit, Directive, Input, inject} from '@angular/core';
import {MatSelect} from '@angular/material/select';
import {MatOption} from '@angular/material/core';
import {startWith, Subscription} from 'rxjs';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Directive({
    selector: 'mat-option[selectAll]',
    standalone: false
})
export class SelectAllDirective implements AfterViewInit {
  @Input({required: true}) allValues: unknown[] = [];

  private matSelect = inject(MatSelect);
  private matOption = inject(MatOption);
  private subs = new Subscription();
  private isUpdating = false;

  public ngAfterViewInit(): void {
    const control = this.matSelect.ngControl?.control;
    if (!control) return;
    this.updateSelectAllState(control.value);

    this.subs.add(
      control.valueChanges.pipe(startWith(control.value)).subscribe(value => {
        if (!this.isUpdating) {
          this.updateSelectAllState(value);
        }
      })
    );

    this.subs.add(
      this.matOption.onSelectionChange.subscribe(event => {
        if (!event.isUserInput) return;

        this.isUpdating = true;

        const current: unknown[] = Array.isArray(control.value)
          ? control.value.filter(v => this.allValues.includes(v))
          : [];

        const allSelected = this.isAllSelected(current);

        if (allSelected) {
          control.setValue([]);
        } else {
          control.setValue([...this.allValues]);
        }

        setTimeout(() => {
          this.isUpdating = false;
          this.updateSelectAllState(Array.isArray(control.value) ? control.value.filter(v => this.allValues.includes(v)) : []);
        }, 0);
      })
    );
  }

  private isAllSelected(value: unknown[] | null): boolean {
    const vals = Array.isArray(value) ? value : [];
    return vals.length > 0 && vals.length === this.allValues.length && this.allValues.every(val => vals.includes(val));
  }

  private updateSelectAllState(currentValue: unknown[] | null): void {
    const vals = Array.isArray(currentValue) ? currentValue.filter(v => this.allValues.includes(v)) : [];
    const allSelected = this.isAllSelected(vals);

    if (allSelected && !this.matOption.selected) {
      this.matOption.select(false);
    } else if (!allSelected && this.matOption.selected) {
      this.matOption.deselect(false);
    }
  }
}
